document.addEventListener('DOMContentLoaded', function () {
  const desc = document.querySelector('.product__description, .product-description, #ProductInfo-template--default .rte'); // 自动匹配 Dawn 产品描述区域
  if (!desc) return;

  // 原始高度与显示限制
  const fullHeight = desc.scrollHeight;
  const maxHeight = 150; // 默认展开前显示约三行（可根据需要调整）

  if (fullHeight <= maxHeight + 10) return; // 若本身内容较短，不显示按钮

  // 初始样式
  desc.style.maxHeight = maxHeight + 'px';
  desc.style.overflow = 'hidden';
  desc.style.transition = 'max-height 0.3s ease';

  // 创建按钮
  const btn = document.createElement('button');
  btn.textContent = 'Show More';
  btn.className = 'cf-toggle-btn';
  desc.insertAdjacentElement('afterend', btn);

  // 点击切换逻辑
  btn.addEventListener('click', function () {
    const isCollapsed = desc.style.maxHeight === maxHeight + 'px';
    if (isCollapsed) {
      desc.style.maxHeight = fullHeight + 'px';
      btn.textContent = 'Show Less';
      btn.classList.add('active');
    } else {
      desc.style.maxHeight = maxHeight + 'px';
      btn.textContent = 'Show More';
      btn.classList.remove('active');
    }
  });
});
